import { render, staticRenderFns } from "./PaperBaseInfo.vue?vue&type=template&id=7d3d013c&scoped=true&"
import script from "./PaperBaseInfo.vue?vue&type=script&lang=js&"
export * from "./PaperBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaperBaseInfo.vue?vue&type=style&index=0&id=7d3d013c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3d013c",
  null
  
)

export default component.exports